"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonTypes = void 0;
var _type = require("../_utils/type");
var ButtonTypes = exports.ButtonTypes = (0, _type.tuple)('primary', 'pay', 'hole', 'weak-hole', 'white-hole', 'link', 'link-weak', 'white', 'collect', 'collect-active');
var ButtonSizeTypes = (0, _type.tuple)('xxl', 'xl', 'l', 'default', 's', 'xs', 'auto');
var MobileButtonSizeTypes = (0, _type.tuple)('xxl', 'xl', 'default', 's');
var ButtonHtmlTypes = (0, _type.tuple)('submit', 'reset', 'button');
var ButtonWidthTypes = (0, _type.tuple)('auto', 'default', 'full');